module.exports = __webpack_public_path__ + "img/aep.3e57ee17.svg";